import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import { IkanoOpenbankingInfoGraph } from './icons/IkanoOpenbankingInfoGraph'
import {
  TermsAndConditions,
  AdditionalParagraphProps,
} from '@components/TermsAndConditions/TermsAndConditions'

const AdditionalParagraph: React.FC<AdditionalParagraphProps> = ({ trans }) => (
  <>
    <div className="ikano__micropayment-info-graph">
      <IkanoOpenbankingInfoGraph />
    </div>
    {(trans?.content?.split('\n') ?? []).map((item: string, index: number) => (
      <div className="generic__paragraph m-0-0-24" key={index}>
        {item}
      </div>
    ))}
  </>
)

export const TermsAndConditionsMicropaymentInfoIkanoOpenBankingPage = observer(() => {
  const store = useContext(StoreContext)
  const { micropaymentInfoOpenBankingPage: trans } = store.TranslationsState.translations

  return (
    <TermsAndConditions
      showHeader={false}
      showTitle={false}
      showRequired={false}
      buttonText={trans.proceed}
      AdditionalParagraph={AdditionalParagraph}
      additionalParagraphProps={{ trans: trans }}
    />
  )
})
